export default __webpack_public_path__ + "static/mingyu.chi-df4c550fe1f32112efd3d179edc2db58.jpeg";